import { Route } from '@angular/router';
import { DeviceDetailsComponent } from '@features/activity-types/order-new-device/device-details/device-details.component';
import { AccessoriesComponent } from '@features/shopping/accessories/accessories.component';
// import { DeviceDetailsComponent } from '@features/shopping/device-details/device-details.component';
import { DeviceListComponent } from '@features/shopping/device-list/device-list.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const order_new_device_with_service_routes: Route[] = [
  {
    path: 'device-list',
    component: DeviceListComponent,
    title: 'Select Device',
    data: { order_type_id: 1 }
  },
  {
    path: 'device-details',
    component: DeviceDetailsComponent,
    title: 'Customize Device',
    data: { order_type_id: 1 }
  },
  {
    path: 'accessories',
    component: AccessoriesComponent,
    title: 'Get Add Ons',
    data: { order_type_id: 1 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 1 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 1 }
  },
  {
    path: '',
    redirectTo: 'device-list',
    pathMatch: 'full'
  }
];
